import { render, staticRenderFns } from "./AddResourceGroupModal.vue?vue&type=template&id=38a42ab0&scoped=true&"
import script from "./AddResourceGroupModal.vue?vue&type=script&lang=js&"
export * from "./AddResourceGroupModal.vue?vue&type=script&lang=js&"
import style0 from "./AddResourceGroupModal.vue?vue&type=style&index=0&id=38a42ab0&prod&lang=less&scoped=true&"
import style1 from "@/assets/less/manage-space/base.less?vue&type=style&index=1&id=38a42ab0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a42ab0",
  null
  
)

export default component.exports